/* Main Header constants */
export const APPLICATION_NAME = 'B2B Data Exchange'
export const HEADER_MENU_ITEM_PROFILE = 'Profile'
export const HEADER_MENU_ITEM_LOGOUT = 'Logout'

export const EDI_REGISTRATION = 'Partner Self Service'

export const APPLICATION_ENVIRONMENT = `${process.env.NODE_ENV}`
